export const SET_MAHNSTUFEN_WERTE = "setMahnstufenWerte";

